import { render, staticRenderFns } from "./repaymentTransfer.vue?vue&type=template&id=661c6995&scoped=true"
import script from "./repaymentTransfer.vue?vue&type=script&lang=js"
export * from "./repaymentTransfer.vue?vue&type=script&lang=js"
import style0 from "./repaymentTransfer.vue?vue&type=style&index=0&id=661c6995&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c6995",
  null
  
)

export default component.exports